import React, { Component, FormEvent } from 'react';
import t from 'rcm-i18n';
import { getCheckoutOrderManager } from 'cart-ui';

interface Props {
  onSubmit?: Function;
  paymentType: string;
  isCartV2?: boolean;
}

interface State {}

// TODO: Add captcha
export default class PaymentFormFree extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  public handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (this.props.isCartV2) {
      getCheckoutOrderManager().then((orderManager) => {
        orderManager.processCurrentOrder({ type: this.props.paymentType, data: {} });
      });
    } else {
      this.props.onSubmit({ type: this.props.paymentType });
    }
  }

  public render() {
    return (
      <form onSubmit={this.handleSubmit} autoComplete="off">
        <br />
        <button className="continueButton btn btn-primary" type="submit">
          {t('Place Order')}
        </button>
      </form>
    );
  }
}
